export var SeatType;
(function(SeatType) {
    SeatType[/**
     * A standard single seat.
     */ "Normal"] = "Normal";
    SeatType[/**
     * A space temporarily or permanently reserved for a single wheelchair (or similar special need) to occupy.
     */ "Wheelchair"] = "Wheelchair";
    SeatType[/**
     * A seat temporarily or permanently reserved for companions of customers using a [[Wheelchair]] seat.
     */ "Companion"] = "Companion";
    SeatType[/**
     * A seat belonging to a seat group, specifically the leftmost seat in a sofa.
     */ "SofaLeft"] = "SofaLeft";
    SeatType[/**
     * A seat belonging to a seat group, specifically one of the middle seats in a sofa.
     */ "SofaMiddle"] = "SofaMiddle";
    SeatType[/**
     * A seat belonging to a seat group, specifically the rightmost seat in a sofa.
     */ "SofaRight"] = "SofaRight";
})(SeatType || (SeatType = {}));

//# sourceMappingURL=seat-type.js.map